module.exports = __webpack_public_path__ + "static/media/qs-lightning.bf96acfe.svg";